export default "__VITE_ASSET__D26dASME__"